import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Grid,
  Typography,
  IconButton,
  InputAdornment,
  Snackbar,
  Alert,
  Link,
  FormControl,
  InputLabel,
  OutlinedInput,
  TextField,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import axios from "axios";
import { user_signin } from "../Api service/APIvariables";
import productsImage from "../assets/products.png";
import mdqLogo from "../assets/mdqlogo.jpeg";
import "../App.css";

function SignIn({
  setsuccessOpen,
  setsuccessMessage,
  setsuccessStatus,
  setsuccessColor,
}) {
  const navigate = useNavigate();
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState(false);
  const [color, setColor] = useState(false);
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(true);

  const onSubmit = (data) => {
    console.log("Submitted Data:", data);

    const serverData = new FormData();
    for (const key in data) {
      serverData.append(key, data[key]);
    }

    if (!navigator.onLine) {
      setMessage("Your internet is offline");
      setOpen(true);
      setStatus(false);
      setColor(false);
    } else {
      axios({
        method: "POST",
        url: user_signin,
        data: serverData,
      })
        .then((res) => {
          if (res.data.error) {
            setMessage(res.data.message);
            setOpen(true);
            setStatus(false);
            setColor("error");
          } else {
            const authObj = {
              token: res.data.token,
              role: "user"
            };
            localStorage.setItem("auth", JSON.stringify(authObj));
            // Keep legacy items for backward compatibility
            localStorage.setItem("user_id", res.data.user_id);
            localStorage.setItem("auth_token", res.data.token);
            navigate(`/`);
            setsuccessOpen(true);
            setsuccessMessage(res.data.message);
            setsuccessStatus(true);
            setsuccessColor(true);
          }
        })
        .catch((err) => {
          setMessage("Oops, something went wrong: " + err.message);
          setOpen(true);
          setStatus(false);
          setColor("error");
        });
    }
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Box sx={{ bgcolor: "rgb(234, 244, 252)", height: "100vh" }}>
      <Snackbar
        open={open}
        autoHideDuration={4000}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setOpen(false)}
          severity={status ? "success" : color === "error" ? "error" : "info"}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
      <Box sx={{ px: 2 }}>
        <Grid container sx={{ height: "100vh" }} alignItems={"center"}>
          {/* Left Column : Image */}
          <Grid
            item
            xs={0}
            md={6}
            sx={{
              display: { xs: "none", md: "flex" },
              justifyContent: "center",
              alignItems: "center",
              padding: 2,
            }}
          >
            <Box
              sx={{
                height: "100%",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 2,
              }}
            >
              <img
                src={productsImage}
                alt="Products"
                style={{
                  maxWidth: "80%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
              />
            </Box>
          </Grid>

          {/* Right Column: Sign-In Form */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: { xs: "auto", sm: "80vh", md: "auto" },
                px: { xs: 2, sm: 4, md: 5 },
                padding: "20px",
                width: { xs: "90%", sm: "80%", md: "70%" },
                mx: "auto",
              }}
            >
              <Box
                sx={{
                  border: "1px solid #eaf4fc",
                  borderRadius: "10px", // Card Style
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)", // Card Style
                  backgroundColor: "white",
                  padding: 4,
                  width: "100%",
                }}
              >
                <img
                  src={mdqLogo}
                  alt="MDQ Logo"
                  style={{
                    display: "block",
                    height: "45%",
                    width: "45%",
                    // marginBottom: "20px",
                    justifyContent: "center",
                    alignItems: "center",
                    alignContent: "center",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                />
                <Typography
                  fontSize={{ xs: 18, sm: 20, md: 24 }}
                  color="#52459f"
                  variant="h5"
                  sx={{ textAlign: "center", fontWeight: 600, marginTop: 1 }}
                >
                  SignIn to QuickCard
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: 12, sm: 13, md: 15 },
                    marginTop: 1,
                    marginBottom: 1,
                    textAlign: "center",
                  }}
                >
                  Welcome, Please sign-in to continue
                </Typography>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <TextField
                    className="mui-textfield"
                    id="email"
                    label="Email"
                    type="text"
                    {...register("email", {
                      required: "Please enter your email",
                    })}
                    variant="outlined"
                    fullWidth
                    error={!!errors.email}
                    helperText={errors.email ? errors.email.message : ""}
                    sx={{
                      mb: 2,
                      // textAlign: "center",
                      // width: "100%",
                      // height: { xs: 10, sm: 10, md: 10 },
                      // padding: "10px 8px",
                      "& .MuiOutlinedInput-root": {
                        borderColor: "#eaf4fc",
                      },
                      "&:hover .MuiOutlinedInput-root": {
                        borderColor: "#eaf4fc",
                      },
                      "&.Mui-focused .MuiOutlinedInput-root": {
                        borderColor: "#eaf4fc",
                      },
                    }}
                  />

                  <TextField
                    id="password"
                    label="Password"
                    type={showPassword ? "text" : "password"}
                    {...register("password", {
                      required: "Please enter your password",
                    })}
                    variant="outlined"
                    fullWidth
                    error={!!errors.password}
                    helperText={errors.password ? errors.password.message : ""}
                    sx={{
                      // mb: 0,
                      // width: "100%",
                      // height: { xs: 10, sm: 10, md: 10 },
                      "& .MuiOutlinedInput-root": {
                        borderColor: "#eaf4fc",
                      },
                      "&:hover .MuiOutlinedInput-root": {
                        borderColor: "#eaf4fc",
                      },
                      "&.Mui-focused .MuiOutlinedInput-root": {
                        borderColor: "#eaf4fc",
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                            // style={{ fontSize: "10px" }}
                          >
                            {showPassword ? (
                              <VisibilityOff
                                style={{ fontSize: "20px", marginTop: "7px" }}
                              />
                            ) : (
                              <Visibility
                                style={{ fontSize: "20px", marginTop: "7px" }}
                              />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />

                  <Link
                    href="/forgot-password"
                    variant="body2"
                    sx={{
                      fontSize: { xs: 12, sm: 13, md: 15 },
                      marginBottom: 1,
                      display: "block",
                      textAlign: "right",
                      mt: 1,
                    }}
                  >
                    Forgot password?
                  </Link>

                  <Button
                    type="submit"
                    sx={{
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      width: "100%",
                      backgroundColor: "#52459f",
                      color: "white",
                      mt: 1,
                    }}
                    variant="contained"
                  >
                    Sign In
                  </Button>
                </form>
                <Typography
                  variant="body2"
                  sx={{
                    marginTop: 2,
                    fontSize: { xs: 12, sm: 13, md: 15 },
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  Don’t have an account?{"  "}
                  <a
                    href="/sign-up"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <span
                      style={{
                        textDecoration: "underline",
                        color: "#1976d2",
                        marginLeft: "6px",
                      }}
                    >
                      {" "}
                      Sign Up
                    </span>
                  </a>
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default SignIn;
